import React, { FC } from 'react';
import { NavigationProps } from '@eta/components';
import ValidateInvitation from './ValidateInvitation';
import UserLayoutContent from '../../common/layoutContent/UserLayoutContent';

interface InvitationProps {
    id: string;
}

export const AcceptInvitation: FC<NavigationProps<InvitationProps>> = (
    props: NavigationProps<InvitationProps>
) => {
    const { match } = props;
    return (
        <UserLayoutContent>
            {match.params.id && (
                <ValidateInvitation id={match.params.id} />
            )}
        </UserLayoutContent>
    );
};
